import { Component, AfterViewInit, ViewChild } from '@angular/core';
import { TablepagedComponent, ColumnDef } from '../../../containers/table/tablepaged/tablepaged.component';
import {  FormAddConfig } from "../../../containers/form/formadd/formadd.component";
import {  FormUpdateConfig } from "../../../containers/form/formupdate/formupdate.component";
import { UpdateAddTableComponent, AttributeDefinition } from "../../basic/update-add-table/update-add-table.component";

@Component({
  selector: 'app-tracks',
  imports: [UpdateAddTableComponent],
  templateUrl: './tracks.component.html',
  styleUrl: './tracks.component.scss',
})
export class TracksComponent {
title = 'Gps tracks';
description = "This are the gps tracks";
path = "/gps_track";
showFormAdd = true
element_name="track";
showUpdateButton = true;
showDeleteButton = true;

config: Array<AttributeDefinition> = [
{ title: 'Id',               store_key: 'Id', 
  column_options:{ linkPostfixValueStoreKey: 'Id' } },
{ title: 'IdUserCreation',   store_key: 'IdUserCreation', hidden: true},
{ title: 'TimeCreation',     store_key: 'TimeCreation' , hidden: true},
{ title: 'Name',             store_key: 'Name' },
{ title: 'Description',      store_key: 'Description' }
];

@ViewChild(TablepagedComponent) table!: TablepagedComponent;

}
